import {StyleSheet, css} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import {BLUE_LIGHT} from 'ui-library/Colors';

import {COMMON_NODE_WIDTH, NODE_NAME_BOX_HEIGHT} from '../procedureMethodNodeCommonConsts';
import {COLUMN_GAP_PIXELS} from '../useConvertedGridLayoutGraph';
import {DropZoneType, MethodDropZone} from './ProcedureMethodDragOverlayTypes';

interface ProcedureDropZoneRendererProps {
  dropZone: MethodDropZone;
  zoom: number;
}

export default function ProcedureDropZoneRenderer(props: ProcedureDropZoneRendererProps): JSX.Element {
  const {dropZone, zoom} = props;

  let dropZoneLeft = 0;
  const dropZonePositionBuffer = (COMMON_NODE_WIDTH / 2 + COLUMN_GAP_PIXELS / 2 - 1) * zoom;

  switch (dropZone.type) {
    case DropZoneType.METHOD_ROOT:
      dropZoneLeft = dropZone.position.x + dropZone.width - dropZonePositionBuffer - 2;
      break;
    case DropZoneType.METHOD_LEAF:
      dropZoneLeft = dropZone.position.x + dropZonePositionBuffer;
      break;
    case DropZoneType.METHOD_EDGE:
      dropZoneLeft = dropZone.position.x + dropZone.width / 2 - zoom;
      break;
    default:
      assert(false, 'Unsupported drop zone type');
  }

  return (
    <div
      className={css(styles.dropZone)}
      style={{
        top: dropZone.position.y + NODE_NAME_BOX_HEIGHT * zoom,
        left: dropZoneLeft,
        width: 4 * zoom,
        height: dropZone.height - NODE_NAME_BOX_HEIGHT * zoom,
      }}
    />
  );
}

const styles = StyleSheet.create({
  dropZone: {
    position: 'absolute',
    background: BLUE_LIGHT,
    borderRadius: '4px',
  },
});
